import { h } from 'preact';
import { useState } from 'preact/hooks';
import { Pagination } from '../Pagination';
import type { ComponentShowcase } from '../registry';

function PaginationShowcaseWrapper() {
  const [page, setPage] = useState(3);
  const [perPage, setPerPage] = useState(10);
  return (
    <Pagination
      page={page}
      totalPages={20}
      onPageChange={setPage}
      perPageOptions={[10, 25, 50]}
      perPage={perPage}
      onPerPageChange={setPerPage}
    />
  );
}

export const showcase: ComponentShowcase = {
  name: 'Pagination',
  category: '📊 Data Display',
  description: 'Paginação com navegação, itens por página e total de páginas',
  usedIn: ['Integrations', 'AgentesPage'],
  example: () => <PaginationShowcaseWrapper />,
};
